import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getPageData } from 'utils/lib/strapi';

const useExcludeAmountOfferingList = () => {
  const queryClient = useQueryClient();
  const strapiContentId = queryClient.getQueryData(['strapiContentId']);
  const { data, isError, isSuccess, isLoading } = useQuery({
    queryKey: ['excludeAmountOfferingList', strapiContentId],
    queryFn: () =>
      getPageData({
        type: 'exclude-amount-offering-lists',
        preview: Boolean(strapiContentId),
        id: strapiContentId,
      }),
    refetchOnMount: true,
  });
  const parsedData = data?.attributes?.excludedOffering?.map((item) => item?.value);
  const truthySuccess = isSuccess && data !== undefined;
  return {
    data: parsedData || [],
    isError,
    isLoading,
    isSuccess: truthySuccess,
  };
};

export default useExcludeAmountOfferingList;
